<template>
  <div class="app-layout">
    <!-- Sidebar Navigation -->
    <aside class="sidebar">
      <div class="brand-container">
        <img src="@/assets/logo1.png" alt="Logo Bank" class="logo" />
        <img src="@/assets/logo.png" alt="Logo Bank" class="logo" />
        <h3>Bank Syariah Mini</h3>
      </div>
      <nav class="nav-links">
        <router-link to="/dashboard">Dasbor</router-link>
        <router-link to="/profile">Profil</router-link>
        
        <!-- Akses 'authStore.isAuthenticated' secara langsung -->
        <router-link
            v-if="authStore.isAuthenticated && ['cs', 'superadmin'].includes(userRole)"
            to="/cs-tools"
        >
            Alat CS
        </router-link>
        
        <router-link
            v-if="authStore.isAuthenticated && ['supervisor', 'superadmin'].includes(userRole)"
            to="/supervisor-tools"
        >
            Persetujuan
        </router-link>
        
        <router-link
            v-if="authStore.isAuthenticated && ['supervisor', 'superadmin'].includes(userRole)"
            to="/master-data/transaction-codes"
        >
            Kode Transaksi
        </router-link>

        <router-link v-if="authStore.isAuthenticated && ['teller', 'superadmin'].includes(userRole)" to="/teller-tools">
            Alat Teller
        </router-link>
        
        <router-link
            v-if="authStore.isAuthenticated && ['marketing', 'superadmin'].includes(userRole)"
            to="/marketing-tools"
        >
            Alat Marketing
        </router-link>

        <router-link
            v-if="authStore.isAuthenticated && userRole === 'superadmin'"
            to="/ledger"
        >
            Buku Besar
        </router-link>
        
        <!-- Link Manajemen User juga perlu 'authStore.isAuthenticated' -->
        <router-link v-if="authStore.isAuthenticated && userRole === 'superadmin'" to="/admin/all-users">
            Manajemen User
        </router-link>
      </nav>
      <div class="user-actions">
         <button @click="handleLogout" class="btn-logout">Logout</button>
      </div>
    </aside>

    <!-- Konten Utama -->
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { useAuthStore } from '@/store/auth';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';

const authStore = useAuthStore();
const router = useRouter();

// Hanya ambil 'userRole' karena hanya itu yang digunakan di template
const { userRole } = storeToRefs(authStore);

const handleLogout = () => {
  authStore.logout();
  router.push('/login');
};
</script>

<style scoped>
  .app-layout {
    display: flex;
    min-height: 100vh;
  }
  .sidebar {
    width: 250px;
    background-color: #2c3e50; /* Warna gelap untuk sidebar */
    color: white;
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    flex-shrink: 0;
  }
  .brand-container { text-align: center; margin-bottom: 2rem; }
  .logo { height: 50px; margin-bottom: 0.5rem; }
  
  .nav-links {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex-grow: 1; /* Mendorong tombol logout ke bawah */
  }
  .nav-links a {
    color: #ecf0f1;
    text-decoration: none;
    padding: 0.75rem 1rem;
    border-radius: 6px;
    transition: background-color 0.2s;
  }
  .nav-links a:hover,
  .nav-links a.router-link-exact-active {
    background-color: #34495e;
    font-weight: bold;
  }
  
  .user-actions .btn-logout { width: 100%; /* Tombol logout lebar penuh */ }

  .main-content {
    flex-grow: 1;
    padding: 2rem;
    background-color: #f4f7f6;
    overflow-y: auto; /* Agar bisa di-scroll jika konten panjang */
  }
  /* Tambahkan media query untuk mobile (mis: sembunyikan sidebar) */
</style>